// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BugFilledSvg from "@fishx/icons-svg/es/asn/BugFilled";
import FishxIcon from '../components/FishxIcon';

var BugFilled = function BugFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BugFilledSvg
  }));
};

BugFilled.displayName = 'BugFilled';
export default React.forwardRef(BugFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BugFilled.js
// module id = 2115
// module chunks = 0